import { render, staticRenderFns } from "./MapBoxDrawDeleteControl.vue?vue&type=template&id=1d1dc566"
import script from "./MapBoxDrawDeleteControl.vue?vue&type=script&lang=ts&setup=true"
export * from "./MapBoxDrawDeleteControl.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./MapBoxDrawDeleteControl.vue?vue&type=style&index=0&id=1d1dc566&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports